import { useState, useEffect } from 'react'
import { KeyValuePairs, If } from 'components/ideal-core-ui'
import { getProposalFileName, getCurrentVersionInfo } from 'components/proposals/Proposal/utils'
import { ReplaceFile } from './ReplaceFile'
import { EditHtml } from './EditHtml'
import cn from 'classnames'
import s from './FileDetails.scss'
import { getToken } from 'utils/authService'
import { timezoneDate } from 'utils/helpers'

const FileDetails = ({ proposal, baseUrl, fileUrl, proposalId, dealName }) => {
  const {
    version,
    versionList,
    createdby,
    createdAt,
    s3ContentKey,
    company,
    contentJson,
    fileSize,
    status,
    proposalTemplateIds,
    pageType
  } = proposal

  const currentVersionInfo = getCurrentVersionInfo(version, versionList)
  const fileName = getProposalFileName(
    dealName,
    company.name,
    currentVersionInfo ? currentVersionInfo.createdAt : createdAt,
    version
  )
  const [templateId] = proposalTemplateIds ? proposalTemplateIds.slice(-1) : []

  const [isHtmlProposal, setIsHtmlProposal] = useState(false)
  const [pages, setPages] = useState([])

  useEffect(() => {
    if (!proposal.id) return
    const pages = JSON.parse(proposal.contentJson)
    const obj = proposal.contentJson ? pages : {}

    if (obj.sections || !proposal.contentJson) {
      setIsHtmlProposal(false)
    } else {
      setIsHtmlProposal(true)
      setPages(pages)
    }
  }, [proposal])

  return (
    <KeyValuePairs
      stackedKeys
      pairs={[
        fileSize
          ? {
              key: 'Current Version',
              keyClass: s.fileTitle,
              value: (
                <section>
                  {createdby && (
                    <div className={s.createdByInfo}>
                      created by {createdby} on {createdAt ? timezoneDate(createdAt, 'h:mm A') : ''}
                    </div>
                  )}
                  <div className={cn(s.linkContainer, { [s.editHtml]: contentJson })}>
                    <div>
                      <a
                        className={s.link}
                        href={`${fileUrl}/${s3ContentKey}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {fileName}
                      </a>
                      <span className={s.createdByInfo}>file size: {fileSize} KB</span>
                    </div>
                    <div className={s.btnContainer}>
                      <If
                        condition={contentJson}
                        fallback={<ReplaceFile proposalId={proposalId} proposal={proposal} />}
                      >
                        <EditHtml
                          proposalId={proposalId}
                          content={contentJson}
                          fileName={fileName}
                          status={status}
                          proposal={proposal}
                          templateId={templateId}
                          isHtmlProposal={isHtmlProposal}
                          pages={pages}
                          pageType={pageType}
                        />
                      </If>
                    </div>
                  </div>
                </section>
              )
            }
          : {},
        {
          key: 'Older Versions',
          keyClass: s.fileTitle,
          value: (
            <div className={cn(s.oldLinkContainer, { [s.editHtml]: contentJson })}>
              {versionList &&
                versionList.map(
                  oldVersion =>
                    oldVersion.version !== version && (
                      <a
                        href={`${baseUrl}/proposals/download/${proposalId}?versionId=${
                          oldVersion.s3VersionId
                        }&x-token-tracking=${getToken()}`}
                        target="_blank"
                        className={s.link}
                        key={oldVersion.version}
                        rel="noopener noreferrer"
                      >
                        {getProposalFileName(
                          dealName,
                          company.name,
                          oldVersion.createdAt,
                          oldVersion.version
                        )}
                      </a>
                    )
                )}
            </div>
          )
        }
      ]}
    />
  )
}

export default FileDetails
